import { render, staticRenderFns } from "./PartnerDialog.vue?vue&type=template&id=2a64f9bd&scoped=true&"
import script from "./PartnerDialog.vue?vue&type=script&lang=js&"
export * from "./PartnerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64f9bd",
  null
  
)

export default component.exports